import React from 'react';
import _ from 'underscore';
import { Col, Row, Button, Alert } from 'react-bootstrap';


import { translate } from 'react-i18next';

import i18next from 'i18next';

@translate(['common'])
export default class ErrorAlert extends React.Component {
  static defaultProps = {
    errorMessage: i18next.t('main.connection_error')
  }


  constructor(props) {
    super(props);



    this.state = {

    };

    //this.onRow = this.onRow.bind(this);

  }





  render() {
    var self = this;

    return (
      <Row>
        <Col xs={5}>
          <Alert bsStyle="danger">
            <div>{this.props.errorMessage} <Button bsStyle="primary"
              onClick={() => self.props.callback()}>{this.props.buttonText}</Button>
            </div>
          </Alert>
        </Col>
      </Row>
    );
  }

}
